import { FC } from "react"
import { useLocation } from "react-router"
import ListBlock from "./blocks/ListBlock"
import ManageBlock from "./blocks/ManageBlock"
import "./index.less"

const Salons: FC = () => {
  const { pathname } = useLocation()
  const pathIdentifier = pathname?.split("/")[pathname?.split("/")?.length - 1]
  const createNewMode = pathIdentifier == "new-salon"
  const selectedUserId = Number(pathIdentifier)

  return (
    <section className={"salons"}>
      {!createNewMode && !selectedUserId && <ListBlock />}
      {(selectedUserId > 0 || createNewMode) && <ManageBlock selectedUserId={selectedUserId} />}
    </section>
  )
}

export default Salons
